/** Thin fetch helpers for the first-party /api/* endpoints (via the Pages Function). */

export async function apiGet(path: string): Promise<Response> {
  return fetch(path, { credentials: "same-origin" });
}

export async function apiPost(path: string, body?: unknown): Promise<Response> {
  return fetch(path, {
    method: "POST",
    credentials: "same-origin",
    headers: body !== undefined ? { "content-type": "application/json" } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
}

export async function errorMessage(res: Response, fallback: string): Promise<string> {
  try {
    const json = (await res.json()) as { error?: string };
    return json.error ?? fallback;
  } catch {
    return fallback;
  }
}
